import { useQuery } from '@tanstack/react-query';

import type { Module } from 'src/types/modulePermission';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

export const useGlobalDashboards = (enabled = true) =>
  useQuery<Module[]>({
    enabled,
    queryKey: ['dashboards'],
    queryFn: ({ signal }) =>
      HttpService.get(apiPaths.DASHBOARD.GLOBAL, {}, true, { signal }).then(
        (response) => response.data.results as Module[],
      ),
  });
